module.exports = __webpack_public_path__ + "static/media/38_B.4b02407e.png";